import { render, staticRenderFns } from "./EdsDiia.vue?vue&type=template&id=6a06799b&"
import script from "./EdsDiia.vue?vue&type=script&lang=js&"
export * from "./EdsDiia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports